import { FC, ReactNode, useMemo } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';

interface IProps {
    children: ReactNode;
    variant?: 'error' | 'warning' | 'success' | 'gray' | 'blue' | 'lightblue';
    type?: 'text' | 'default' | 'large';
    className?: string;
}

const cx = classNames.bind(styles);

const Status: FC<IProps> = ({ children, variant, className, type = 'default' }) => {
    const rootStyles = useMemo(
        () => cx([styles.wrapper, className, variant, type]),
        [className, variant, type]
    );

    return <div className={rootStyles}>{children}</div>;
};

export default Status;
